module.exports = __webpack_public_path__ + "img/bg05.a951ce20.jpg";